import React, { useState, useEffect } from 'react';
// Note: You'll need to include Bootstrap CSS in your main file or index.html:
import 'bootstrap/dist/css/bootstrap.min.css';
import './Services.css'
import img1 from '../Components/Images/service/image1.webp'
import img2 from '../Components/Images/esl/Nebular_collection.jpg'
import Featuredproduct from './Featuredproduct';
import ServicesSection from './ServiceSection';
// Service data
const testimonials = [
  {
    id: 1,
    text: "Sensetech Trading LLC helped me protect my store with their security system. The team came on time, explained everything, and installed it fast. Now I feel safe and my customers are happy too.",
    name: "Rashid",
    title: "Supermarket Owner, Al-Karama"
  },
  {
    id: 2,
    text: "Sensetech Trading LLC gave us a barcode printer and POS device. It makes billing easy and fast. They also answered all our questions patiently. We are very happy with their support.",
    name: "Sara",
    title: "Restaurant Owner, Al-Jaddaf"
  },
  {
    id: 3,
    text: "We needed a modern security solution for our office building. Sensetech Trading LLC delivered with smart integration and excellent support. Their team's expertise made the whole process seamless.",
    name: "Ahmed",
    title: "Business Manager, Al-Jaffliya"
  }
];
const services = [
  // {
  //   id: 1,
  //   title: "TIJ Printers",
  //   description: "High-speed thermal inkjet printing solutions for clear, consistent coding and marking.",
  //   icon: <i className="bi bi-printer-fill"></i>,
  //   color: "primary",
  //   url:'/thermal-inkjet-printer'
  // },
  {
    id: 2,
    title: "Weighing Scales",
    description: "Precision retail scales with advanced features for accurate measurements and pricing.",
    icon: <i className="bi bi-sliders"></i>,
    color: "success",
    url:'retail-scales'
  },
  // {
  //   id: 3,
  //   title: "Fiber Laser",
  //   description: "Permanent, high-contrast marking solutions for various materials with precise control.",
  //   icon: <i className="bi bi-lightning-fill"></i>,
  //   color: "danger",
  //   url:'laser-printer'
  // },
  {
    id: 4,
    title: "POS Systems",
    description: "Complete point-of-sale solutions to streamline transactions and inventory management.",
    icon: <i className="bi bi-cash-register"></i>,
    color: "info",
    url:'/sunmi-pos'
  },
  {
    id: 5,
    title: "EAS Security",
    description: "Electronic article surveillance systems to protect merchandise and prevent theft.",
    icon: <i className="bi bi-shield-lock-fill"></i>,
    color: "warning",
    url:'/eas-system'
  },
  {
    id: 6,
    title: "Digital Labels (ESL)",
    description: "Electronic shelf labels for dynamic pricing and real-time product information.",
    icon: <i className="bi bi-tag-fill"></i>,
    color: "secondary",
    url:'/electronic-shelf-label'
  },
  {
    id: 7,
    title: "Self-Kiosk",
    description: "Self-service solutions to enhance customer experience and operational efficiency.",
    icon: <i className="bi bi-display"></i>,
    color: "dark"
  },
  {
    id: 8,
    title: "Barcode Printers",
    description: "Reliable barcode printing solutions for inventory management and product tracking.",
    icon: <i className="bi bi-upc-scan"></i>,
    color: "primary",
    url:'barcode-products'
  }
];
// Featured service content
const featuredService = {
  title: "Electronic Shelf Label",
  description: "Upgrade your retail environment with our advanced Electronic Shelf Label (ESL) System. Replace traditional paper tags with dynamic, wireless e-ink displays that ensure real-time pricing accuracy, improved efficiency, and modern customer engagement.",
  features: [
    "Real-time Price Updates",
    "Wireless & Battery Efficient",
    "Centralized Cloud Management",
    "Dynamic Promotions & Offers"
  ]
};


// Main component
export default function ServicesPage() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-wave-section position-relative">
        {/* Background image container */}
        <div className="wave-image-container">
          <img 
            src={img1}
            alt="Services Header" 
            className="wave-background-image"
          />
        </div>
        
        {/* Content overlay */}
        <div className="container position-relative z-index-1">
          <div className="row align-items-center min-vh-60">
            <div className={`col-md-6 ${isVisible ? 'animate__animated animate__fadeInLeft' : ''}`}>
              <h1 className="fw-bold display-4 mb-3 text-white">Our Services</h1>
              <p className="lead text-white-50 mb-4" style={{fontFamily:"Poppins"}}>Smart Solutions for Retail & More</p>
              <button className="btn btn-light btn-lg text-primary d-inline-flex align-items-center" style={{fontFamily:"Poppins"}}>
                Explore Services <i className="bi bi-chevron-right ms-2"></i>
              </button>
            </div>
            <div className={`col-md-6 mt-5 mt-md-0 ${isVisible ? 'animate__animated animate__fadeInRight' : ''}`}>
              
            </div>
          </div>
        </div>
        
        {/* Wave shape divider */}
        <div className="position-absolute bottom-0 start-0 end-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-100">
            <path fill="#f8f9fa" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-5 py-md-6 bg-gradient">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold display-6 mb-3">Our Complete <span className="" style={{
            background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            display: "inline-flex",
            alignItems: "center",
            textDecoration: "none",
            marginTop: "auto",
          }}>Service Offerings</span></h2>
          <p className="text-muted mx-auto lead" style={{maxWidth: "700px"}}>
            Discover our comprehensive range of retail technology solutions designed to optimize your operations and enhance customer experience.
          </p>
        </div>
        
        <div className="row g-4">
          {services.map((service) => (
            <div key={service.id} className="col-md-6 col-lg-3">
              <div className={`card h-100 border-0 shadow-lg rounded-4 transition-all hover-lift overflow-hidden service-card-${service.color}`}>
                <div className={`card-body p-4 position-relative`} style={{fontFamily: "Poppins"}}>
                  <div className={`position-absolute top-0 end-0 p-3 text-${service.color} opacity-25`}>
                    <span className="fs-1">
                      {service.icon}
                    </span>
                  </div>
                  <div className={`icon-box rounded-circle bg-${service.color} bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-4`} style={{width: "60px", height: "60px"}}>
                    <span className={`fs-4 text-${service.color}`}>
                      {service.icon}
                    </span>
                  </div>
                  <h3 className="fs-4 fw-bold mb-3">{service.title}</h3>
                  <p className="text-muted mb-4">{service.description}</p>
                  <a href={service.url} className={`btn btn-sm btn-outline-${service.color} rounded-pill px-3 fw-semibold btn-learn-more`}>
                    Learn more <i className="bi bi-arrow-right ms-1"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <style jsx>{`
        .bg-gradient {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
        
        .hover-lift {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .hover-lift:hover {
          transform: translateY(-8px);
          box-shadow: 0 1rem 3rem rgba(0,0,0,.15)!important;
        }
        
        .rounded-4 {
          border-radius: 1rem !important;
        }
        
        .card {
          border-bottom: 3px solid transparent;
          transition: all 0.3s ease;
        }
        
        .card:hover {
          border-bottom: 3px solid;
        }
        
        .service-card-primary:hover {
          border-color: var(--bs-primary);
        }
        
        .service-card-success:hover {
          border-color: var(--bs-success);
        }
        
        .service-card-danger:hover {
          border-color: var(--bs-danger);
        }
        
        .service-card-info:hover {
          border-color: var(--bs-info);
        }
        
        .service-card-warning:hover {
          border-color: var(--bs-warning);
        }
        
        .service-card-secondary:hover {
          border-color: var(--bs-secondary);
        }
        
        .service-card-dark:hover {
          border-color: var(--bs-dark);
        }
        
        .btn-learn-more {
          transition: all 0.3s ease;
        }
        
        .service-card-primary:hover .btn-learn-more {
          background-color: var(--bs-primary);
          color: white !important;
        }
        
        .service-card-success:hover .btn-learn-more {
          background-color: var(--bs-success);
          color: white !important;
        }
        
        .service-card-danger:hover .btn-learn-more {
          background-color: var(--bs-danger);
          color: white !important;
        }
        
        .service-card-info:hover .btn-learn-more {
          background-color: var(--bs-info);
          color: white !important;
        }
        
        .service-card-warning:hover .btn-learn-more {
          background-color: var(--bs-warning);
          color: white !important;
        }
        
        .service-card-secondary:hover .btn-learn-more {
          background-color: var(--bs-secondary);
          color: white !important;
        }
        
        .service-card-dark:hover .btn-learn-more {
          background-color: var(--bs-dark);
          color: white !important;
        }
      `}</style>
    </section>

    

      <section>
        <Featuredproduct/>
      </section>

      {/* Featured Service */}
      <section className="py-5 py-md-6 bg-white">
        <div className="container">
          <div className="card border-0 shadow-lg overflow-hidden">
            <div className="row g-0">
              <div className="col-lg-6 p-4 p-md-5">
                <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-4">Featured Service</span>
                <h3 className="fw-bold fs-2 mb-3">{featuredService.title}</h3>
                <p className="text-muted mb-4">{featuredService.description}</p>
                
                <ul className="list-unstyled mb-4">
                  {featuredService.features.map((feature, index) => (
                    <li key={index} className="d-flex align-items-center mb-3">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <button className="btn btn-primary d-inline-flex align-items-center">
                  Request Demo <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
              
              <div className="col-lg-6">
                <div className="h-100 d-flex align-items-center justify-content-center p-5">
                  <img src={img2}></img>
                  {/* <div className="bg-white bg-opacity-10 rounded-3 p-4 text-center" style={{maxWidth: "400px"}}>
                    <div className="rounded-3 bg-primary bg-opacity-25 p-5 mb-4">
                      <div className="display-1 text-white">💻</div>
                    </div>
                    <div className="bg-white bg-opacity-25 rounded p-1 w-75 mb-2"></div>
                    <div className="bg-white bg-opacity-15 rounded p-1 w-100 mb-2"></div>
                    <div className="bg-white bg-opacity-15 rounded p-1 w-75 mb-3"></div>
                    <div className="mt-4 d-flex justify-content-center gap-2">
                      <div className="bg-white rounded-circle p-3" style={{width: "40px", height: "40px"}}>
                        <div className="bg-primary rounded-circle" style={{width: "100%", height: "100%"}}></div>
                      </div>
                      <div className="bg-white rounded-circle p-3" style={{width: "40px", height: "40px"}}>
                        <div className="bg-success rounded-circle" style={{width: "100%", height: "100%"}}></div>
                      </div>
                      <div className="bg-white rounded-circle p-3" style={{width: "40px", height: "40px"}}>
                        <div className="bg-danger rounded-circle" style={{width: "100%", height: "100%"}}></div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-5 bg-light ">
        <div className="container">
          <div className="ctabanner rounded-3 p-4 p-md-5 shadow-lg">
            <div className="row align-items-center">
              <div className="col-lg-7 mb-4 mb-lg-0 text-center text-lg-start text-white">
                <h3 className="fw-bold fs-2 mb-3">Need help choosing the right solution?</h3>
                <p className="text-white-50 mb-0">Our experts are ready to help you find the perfect fit for your business needs and budget. Get personalized guidance today.</p>
              </div>
              <div className="col-lg-5">
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                  
                  <button
                    variant="outline-primary"
                    className="me-2"
                    onClick={() => window.open('https://wa.me/97366711158?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20products', '_blank')}
                  >
                    <i className="bi bi-telephone-fill me-2"></i> Call Us
                  </button>
                  
                  <button className="btn btn-dark fw-semibold d-inline-flex align-items-center justify-content-center">
                    <i className="bi bi-chat-fill me-2"></i> Request a Consultation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Testimonials (Optional) */}
      <section className="py-5 py-md-6 bg-white">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold fs-1 mb-3">Trusted by <span style={{
              background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              display: "inline-flex",
              alignItems: "center",
              textDecoration: "none",
              marginTop: "auto",
            }}>Retailers Worldwide</span></h2>
            <p className="text-muted mx-auto" style={{maxWidth: "700px"}}>See what our clients have to say about our retail technology solutions.</p>
          </div>
          
          <div className="row g-4">
      {testimonials.map((testimonial) => (
        <div key={testimonial.id} className="col-md-4">
          <div className="card h-100 border-0 shadow-sm p-4">
            <div className="card-body">
              <div className="mb-3 text-warning">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="bi bi-star-fill me-1"></i>
                ))}
              </div>
              <p className="text-muted fst-italic mb-4">"{testimonial.text}"</p>
              <div className="d-flex align-items-center">
                <div 
                  className="bg-secondary rounded-circle me-3" 
                  style={{width: "48px", height: "48px"}}
                ></div>
                <div>
                  <h5 className="fw-semibold mb-1">{testimonial.name}</h5>
                  <p className="text-muted small mb-0">{testimonial.title}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
        </div>
      </section>

     
    </div>
  );
}